export enum Colors {
  TEAL = "#41EAD4",
  RED = "#F50744",
  LIGHT_PURPLE = "#9D8DF1",
  DARK_BLUE = "#020887",
}

export const SignupReferralOptions = [
  { value: "word_of_mouth", label: "Word of mouth" },
  { value: "website", label: "Another Website" },
  { value: "online_search", label: "Online search" },
  { value: "news", label: "In the news" },
  { value: "social_media", label: "Social media" },
  { value: "care_home", label: "Care home" },
  { value: "celebrant_or_officiant", label: "Celebrant/Officiant" },
  { value: "charity", label: "Charity" },
  { value: "funeral_director", label: "Funeral director" },
  { value: "health_care_worker", label: "Health care worker" },
  { value: "hospice", label: "Hospice" },
  { value: "local_council", label: "Local council" },
  { value: "registrar", label: "Registrar" },
  { value: "other", label: "Other" },
];

export enum SettldContactInfo {
  Telephone = "+44 3331 111111",
  WhatsApp = "+44 7367 868043",
  ContactUs = "https://www.settld.care/contact/",
  Email = "support@settld.care",
  TermsAndConditionsUrl = "https://www.settld.care/settld-terms-and-conditions",
  PrivacyPolicyUrl = "https://www.settld.care/settld-privacy-policy-2",
  ReviewUrl = "https://www.settld.care/reviews/",
  TrustPilotUrl = "https://uk.trustpilot.com/review/settld.care",
  ContributionUrl = "https://monzo.com/pay/r/kind-call-ltd_8LIeBvpj4gPQDH",
  CoreWebsiteUrl = "https://www.settld.care/",
  IntestacyRulesUrl = "https://www.settld.care/what-if-theres-no-will-intestacy-rules/",
  CookiePolicyUrl = "https://www.settld.care/legal/cookie-policy.html",
}

export enum NOTIFY_NOW_CONTACT_INFO {
  Telephone = "+44 3331 111111",
  ContactUs = "https://notifynow.uk/notifier-contactus",
  WhatsApp = "+44 7367 868043",
  Email = "support@notifynow.uk",
  TermsAndConditionsUrl = "https://www.settld.care/settld-terms-and-conditions",
  PrivacyPolicyUrl = "https://www.settld.care/settld-privacy-policy-2",
  ReviewUrl = "https://www.settld.care/reviews/",
  TrustPilotUrl = "https://uk.trustpilot.com/review/settld.care",
  ContributionUrl = "https://monzo.com/pay/r/kind-call-ltd_8LIeBvpj4gPQDH",
  CoreWebsiteUrl = "https://notifynow.uk/",
  IntestacyRulesUrl = "https://www.settld.care/what-if-theres-no-will-intestacy-rules/",
  CookiePolicyUrl = "https://www.settld.care/legal/cookie-policy.html",
}

export const FILE_NAME_REGEX = /[^\w.\- ]+/g;
export const ACCEPTABLE_FILE_TYPES: string = ".pdf,.png,.jpg,.jpeg";
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

export const READABLE_ACCEPTABLE_MIME_TYPES: string = "PDF, JPEG, PNG";
export const READABLE_MAX_FILE_SIZE: string = "10 MB";
export const READABLE_MAX_FILE_SIZE_PDF: string = "10 MB";
export const READABLE_MAX_FILE_SIZE_NON_PDF: string = "10 MB";
export type MIME = "application/pdf" | "image/png" | "image/jpeg" | "image/jpg";
export const PDF_MIME = "application/pdf";

export const FIlE_RESTRICTIONS_MSG: string = `Supported types ${READABLE_ACCEPTABLE_MIME_TYPES},
   Pdf Max size: ${READABLE_MAX_FILE_SIZE_PDF},
   JPEG/PNG Max size: ${READABLE_MAX_FILE_SIZE_NON_PDF}.`;

export const ACCEPTABLE_MIME_TYPES: string[] = [
  "application/pdf",
  "image/png",
  "image/jpeg",
  "image/jpg",
];

export const AcceptedFileTypes = {
  "application/pdf": [".pdf"],
  "image/png": [".png"],
  "image/jpeg": [".jpg", ".jpeg"],
};

// export const COMPRESSABLE_MIME_TYPES: string[] = ["image/png", "image/jpeg", "image/jpg"];

const STAGING_QUILTER_ID: string = "121c8eec-b386-4c69-8cb1-99f401c2e6cb";
const PROD_QUILTER_ID: string = "95afe55f-9602-4bd6-b31b-71fbcf934613";

export const QUILTER_GROUP: string[] = [STAGING_QUILTER_ID, PROD_QUILTER_ID];

// UUID validation regex (RFC 4122 compliant)
export const UUID_REGEX =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
export const PCA_DATA_SHARING_PRIVACY_POLICY = "https://phillips-cohen.co.uk/contact/privacy/";
